
// 分享活动路由管理
export default{
    path: 'shareActivity',
    name: 'shareActivity',
    component: () => import('@/components/RouterView'),
    redirect: '/manage/shareActivity/list',
    meta: {title: '分享活动'},
    children: [{
        path: 'list',
        name: 'shareActivityList',
        component: () => import('@/views/manage/shareActivity/list'),
        meta: {title: '分享活动', showTitle:false}
    },{
        path: 'add/step1',
        name: 'shareActivityAddStep1',
        component: () => import('@/views/manage/shareActivity/edit/step1.vue'),
        meta: {title: '创建分享活动', showTitle:false}
    },{
        path: 'edit/step1/:id',
        name: 'shareActivityEditStep1',
        component: () => import('@/views/manage/shareActivity/edit/step1.vue'),
        meta: {title: '编辑分享活动', showTitle:false},
        props: true
    },{
        //一步化后 step2 已并入单页编辑 (需求 7120449125), 老链接重定向防 404
        path: 'edit/step2/:id',
        redirect: to => ({ path: `/manage/shareActivity/edit/step1/${to.params.id}`, query: to.query })
    },{
        path: 'edit/finish/:id',
        name: 'shareActivityEditFinish',
        component: () => import('@/views/manage/shareActivity/edit/finish.vue'),
        meta: {title: '提交审核'},
        props: true
    }]
}
